import React, { Component } from 'react'
import { Field, Columns, Button } from 'components/elements'
import { apiProcess } from '../../../api/api.js'
import * as Yup from 'yup'
import PasswordInput from '../../../auth/passwords/passwordInput'
import './basicInfoScreen.css'
import * as Cookies from 'js-cookie'
import {
  USER_AVATAR_DEFAULT_ID,
  USER_AVATAR_DEFAULT_URL,
} from '../../../../constants/images/sizesAndQuality'
import AppContainer from '../../../context/AppContainer'
import { Subscribe } from 'unstated'
import { withRouter } from 'react-router'
import InlineReferral from '../../../referrals/accept/microInput/mircoInput.js'
import {
  trackUserSignedUp,
  createKlaviyoProfile,
  subscribeUser,
} from './../../../elements/klaviyoTracking/userSignUp'
import {
  trackSignUpWizardScreen,
  trackSignUp,
  trackSignUpWizardScreenAttempt,
} from '../../../elements/tracking/signupTracking.js'
import CustomDateOfBirthPicker from '../birthdate/birthdate.js'

const basicValidationSchema = Yup.object().shape({
  emailAddress: Yup.string()
    .nullable()
    .email('Email address is not valid.')
    .required('Email is required.'),
  firstName: Yup.string()
    .nullable()
    .required('First Name is required.'),
  lastName: Yup.string()
    .nullable()
    .required('Last Name is required.'),
  birthDate: Yup.string()
  .nullable()
  .required('Birth Date is required.'),
  password: Yup.string()
    .nullable()
    .min(10, 'Password must be at least 10 characters.')
    .required('Password is required.'),
  acceptedTerms: Yup.boolean().oneOf(
    [true],
    'You must agree to our terms of service.'
  ),
})

class SignUpBasicInfo extends Component {
  constructor(props) {
    super(props)

    this.state = {
      basicValues: {
        emailAddress: '',
        firstName: '',
        lastName: '',
        password: '',
        birthDate: '',
        acceptedTerms: false,
        defaultReferralCode: 'TWISTED',
      },
      basicErrors: {
        emailAddress: false,
        firstName: false,
        lastName: false,
        password: false,
        birthDate: false,
        acceptedTerms: false,
      },
      referralCode: props.auth ? props.auth.state.refCode : '',
      basicLoading: false,
      basicDisabled: false,
      birthYear: '',
      birthMonth: '',
      birthDate: '',
      birthError: '',
      showReferralBox: true,
      generalError: false,
      emailExists: false,
      emailExistsErrorMessage:
        '<span> Login or reset your password to access your account.</span>',
    }
  }

  componentDidMount = () => {
    this.testReferralsURLS()

    if (!document.getElementById("grecaptcha")) {
      const recaptcha = document.createElement("script");
      recaptcha.setAttribute("id", "grecaptcha")
      recaptcha.setAttribute("src", `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_GOOGLE_RECAPTCHA_V3_SITE_KEY}`)
      document.body.appendChild(recaptcha)
    }
  }

  testReferralsURLS = () => {
    //This is not the best we can do. But, it's fine for now.
    let isRefPage = this.props.location.pathname.startsWith('/ref')

    if (isRefPage) {
      this.setState({ showReferralBox: false })
    }
  }

  checkAndRedirect = (type, openLoginModal) => {
    if (type === 'login') {
      openLoginModal(this.bookReservation)
      return false
    } else {
      openLoginModal(this.bookReservation)
      return false
    }
  }

  createNewUser = (updateAuthState, grecaptchaToken) => {
    this.setState({
      generalError: false,
    })

    let apiURL = 'users'

    let listingData = {
      first_name: this.state.basicValues.firstName,
      last_name: this.state.basicValues.lastName,
      birthdate: this.state.basicValues.birthDate,
      email: this.state.basicValues.emailAddress,
      password: this.state.basicValues.password,
      terms_of_service_agreed: this.state.basicValues.acceptedTerms,
      referral_code: this.state.referralCode ? 
        this.state.referralCode : this.state.basicValues.defaultReferralCode,
      grecaptcha_token: grecaptchaToken
    }

    apiProcess(
      apiURL,
      listingData,
      'create-account',
      'Sign Up Basic Info Screen'
    )
      .then(
        function(responseData) {
          Cookies.set('userToken', responseData.token)
          Cookies.set('userRefreshToken', responseData.refresh_token)
          Cookies.set('token_time', Date.now() + 120000) //2 mins in milliseconds
          Cookies.set('userAvatar', USER_AVATAR_DEFAULT_URL)
          Cookies.set('userAvatarID', USER_AVATAR_DEFAULT_ID)
          Cookies.set('userID', responseData.user.user_pretty_id)
          Cookies.set('userEmail', this.state.basicValues.emailAddress)
          Cookies.set(
            'userFullName',
            this.state.basicValues.firstName +
              ' ' +
              this.state.basicValues.lastName
          )
          Cookies.set('userFirstName', this.state.basicValues.firstName)
          Cookies.set('userBirthDate', this.state.basicValues.birthDate)
          Cookies.set('userLastName', this.state.basicValues.lastName)
          Cookies.set('userIsPartner', responseData.user.is_partner)
          Cookies.set('vouchedPublicKey', responseData.vouched_public_key)
          Cookies.set('vouchedWebhookUrl', responseData.vouched_webhook_url)
          trackSignUp({
            pretty_id: responseData.user.user_pretty_id,
            first_name: this.state.basicValues.firstName,
            last_name: this.state.basicValues.lastName,
            email: this.state.basicValues.emailAddress,
            sign_up_through_referrals: this.state.referralCode ? true : false, //test this later.
            ref_code: this.state.referralCode,
          })

          trackUserSignedUp(
            this.state.basicValues.emailAddress,
            this.state.basicValues.firstName,
            this.state.basicValues.lastName
          )

          subscribeUser(this.state.basicValues.emailAddress)

          createKlaviyoProfile(
            this.state.basicValues.emailAddress,
            this.state.basicValues.firstName,
            this.state.basicValues.lastName
          )

          trackSignUpWizardScreen({
            screen: 'Basic Info',
            step_number: this.props.stepNumber,
          })

          updateAuthState()

          if (this.state.showReferralBox === false) {
            this.props.auth.onModalClose()
          }

          this.props.onSuccess()
        }.bind(this)
      )
      .catch(
        function(responseData) {
          let errorMessage = null
          let errorCode = responseData.code
          let errorType = 'Submission - Server'

          if (!(typeof responseData?.errorResponseData === undefined)) {
            if (responseData?.errorResponseData?.hasOwnProperty('errors')) {
              if (responseData?.errorResponseData?.errors?.length > 0) {
                errorMessage =
                  responseData?.errorResponseData?.error_messages[0]
                if (
                  responseData?.errorResponseData?.errors[0] ===
                  'captcha-failed'
                ) {
                  errorMessage =
                    'Invalid CAPTCHA. Please try again!'
                  this.setState({
                    emailExists: false,
                  })
                }
                else if (
                  responseData?.errorResponseData?.errors[0] ===
                  'duplicate-email'
                ) {
                  errorMessage =
                    'This email is already registered.' +
                    this.state.emailExistsErrorMessage
                  this.setState({
                    emailExists: false,
                  })
                } else {
                  this.setState({
                    emailExists: false,
                  })
                }
              }
            }
          } else {
            errorMessage = 'We are having issues right now. Please try again.'
          }

          trackSignUpWizardScreenAttempt(
            'Basic Info',
            {
              error_message: errorMessage,
              error_code: errorCode,
              error_type: errorType,
            },
            this.props.stepNumber
          )
          this.setState({
            generalError: errorMessage,
            basicLoading: false,
            basicDisabled: false,
          })
        }.bind(this)
      )
  }

  updatePasswordState = (passwordScore, password) => {
    this.setState((state) => {
      state.basicErrors['password'] = null
      state.basicValues['password'] = password
      state.passwordStrength = passwordScore
      return state
    })
  }

  handleBasicInfo = (event, updateAuthState) => {
    event.preventDefault()

    this.setState({
      basicLoading: true,
      basicDisabled: true,
      generalError: false,
      emailExists: false,
    })

    const _this = this

    window.grecaptcha.ready(function() {
      window.grecaptcha.execute(
        process.env.REACT_APP_GOOGLE_RECAPTCHA_V3_SITE_KEY,
        { action: 'signup' }
      ).then(function(grecaptchaToken) {
        // Add your logic to submit to your backend server here.
        basicValidationSchema
          .validate(
            {
              emailAddress: _this.state.basicValues.emailAddress,
              firstName: _this.state.basicValues.firstName,
              birthDate: _this.state.basicValues.birthDate,
              lastName: _this.state.basicValues.lastName,
              password: _this.state.basicValues.password,
              acceptedTerms: _this.state.basicValues.acceptedTerms,
            },
            { abortEarly: false }
          )
          .then(
            function(responseData) {
              if (_this.state.passwordStrength < 4) {
                trackSignUpWizardScreenAttempt(
                  'Basic Info',
                  {
                    error_message: 'Form Validation',
                    error_code: 'UI',
                    error_type: 'UI',
                  },
                  _this.props.stepNumber
                )
                _this.setState((state) => {
                  state.basicErrors['password'] = 'Please type a stronger password.'
                  state.basicLoading = false
                  state.basicDisabled = false
                  return state
                })
              } else {
                _this.createNewUser(updateAuthState, grecaptchaToken)
              }
            }.bind(_this)
          )
          .catch(
            function(responseData) {
              for (let i = 0; i < responseData.inner.length; i++) {
                _this.setState((state) => {
                  state.basicErrors[responseData.inner[i]['path']] =
                    responseData.inner[i]['message']
                  return state
                })
              }

              trackSignUpWizardScreenAttempt(
                'Basic Info',
                {
                  error_message: 'Form Validation',
                  error_code: 'UI',
                  error_type: 'UO',
                },
                _this.props.stepNumber
              )

              _this.setState({
                basicLoading: false,
                basicDisabled: false,
              })
            }.bind(_this)
          )
      });
    });
  }

  handleTermsChange = (checked) => {
    this.setState((state) => {
      state.basicErrors['acceptedTerms'] = false
      return state
    })
    if (checked) {
      this.setState((state) => {
        state.basicValues['acceptedTerms'] = true
        return state
      })
    } else {
      this.setState((state) => {
        state.basicValues['acceptedTerms'] = false
        return state
      })
    }
  }

  referralSuccess = (code) => {
    this.setState({
      referralCode: code,
      basicLoading: false,
      basicDisabled: false,
    })
  }

  handleDateChange = (field, value) => {
    this.setState((state) => {
      const newValues = { ...state.basicValues, [field]: value }
      const newErrors = { ...state.basicErrors, [field]: null }
      return { basicValues: newValues, basicErrors: newErrors }
    })
  }

  render() {
    const {
      basicValues,
      basicErrors,
      generalError,
      basicLoading,
      basicDisabled,
      showReferralBox,
    } = this.state

    return (
      <Subscribe to={[AppContainer]}>
        {(auth) => {
          return (
            <React.Fragment>
              <form onSubmit={(e) => this.handleBasicInfo(e, auth.logIn)}>
                {generalError && (
                  <div className="message is-danger mt-3 mb-0">
                    <div
                      className="message-body"
                      dangerouslySetInnerHTML={{ __html: generalError }}
                    />
                  </div>
                )}
                <Columns>
                  <Columns.Column>
                    <Field
                      id="email_address"
                      name="email_address"
                      placeholder="Email Address"
                      fullwidth
                      showErrors={false}
                      error={basicErrors.emailAddress}
                      onChange={
                        ({ value }) =>
                          this.setState((state) => {
                            state.basicValues['emailAddress'] = value.trim()
                            state.basicErrors['emailAddress'] = false
                            return state
                          })
                        //this.handleMakeChange(data.value)
                      }
                      size="medium"
                      iconLeft="fal fa-envelope"
                      value={basicValues.emailAddress}
                    />
                    {this.state.emailExists && (
                      <div className="custom-error">
                        This email already has an account.
                      </div>
                    )}
                    {basicErrors.emailAddress && (
                      <div
                        className="has-text-danger is-size-7"
                        style={{ marginTop: '-.5rem' }}
                      >
                        {basicErrors.emailAddress}
                      </div>
                    )}
                  </Columns.Column>
                </Columns>
                <Columns>
                  <Columns.Column>
                    <Field
                      id="fist_name"
                      name="fist_name"
                      placeholder="First Name"
                      fullwidth
                      error={basicErrors.firstName}
                      showErrors={false}
                      onChange={({ value }) =>
                        this.setState((state) => {
                          state.basicValues['firstName'] = value
                          state.basicErrors['firstName'] = false
                          return state
                        })
                      }
                      size="medium"
                      iconLeft="fal fa-user"
                      value={basicValues.firstName}
                    />
                    {basicErrors.firstName && (
                      <div
                        className="has-text-danger is-size-7"
                        style={{ marginTop: '-.5rem' }}
                      >
                        {basicErrors.firstName}
                      </div>
                    )}
                  </Columns.Column>
                </Columns>
                <Columns>
                  <Columns.Column>
                    <Field
                      name="last_name"
                      id="last_name"
                      placeholder="Last Name"
                      fullwidth
                      error={basicErrors.lastName}
                      showErrors={false}
                      onChange={
                        ({ value }) =>
                          this.setState((state) => {
                            state.basicValues['lastName'] = value
                            state.basicErrors['lastName'] = false
                            return state
                          })
                        //this.handleMakeChange(data.value)
                      }
                      size="medium"
                      iconLeft="fal fa-user"
                      value={basicValues.lastName}
                    />
                    {basicErrors.lastName && (
                      <div
                        className="has-text-danger is-size-7"
                        style={{ marginTop: '-.5rem' }}
                      >
                        {basicErrors.lastName}
                      </div>
                    )}
                  </Columns.Column>
                </Columns>
                <Columns>
                  <Columns.Column>
                    <CustomDateOfBirthPicker
                      onChange={this.handleDateChange}
                      basicValues={basicValues}
                      basicErrors={basicErrors}
                    />
                  </Columns.Column>
                </Columns>
                <Columns>
                  <Columns.Column>
                    <PasswordInput
                      onChange={this.updatePasswordState}
                      error={basicErrors.password}
                      size={'medium'}
                    />
                    {basicErrors.password && (
                      <div className="has-text-danger is-size-7">
                        {basicErrors.password}
                      </div>
                    )}
                  </Columns.Column>
                </Columns>
                {showReferralBox && (
                  <Columns className="my-0">
                    <Columns.Column className="">
                      <InlineReferral
                        callDescription={'Referral Call from Sign Up Modal'}
                        size={'normal'}
                        shortDescription={'signup'}
                        onChange={(data) =>
                          this.setState({ referralCode: data })
                        }
                        onSuccessCode={(data) => this.referralSuccess(data)}
                        onFailureCode={(data) =>
                          this.setState({
                            basicDisabled: false,
                            referralCode: null,
                          })
                        }
                        //onSuccessCode={(data) => this.setState({ basicLoading : false })}
                        onLoading={(data) =>
                          this.setState({ basicDisabled: true })
                        }
                      />
                    </Columns.Column>
                  </Columns>
                )}
                <Columns>
                  <Columns.Column>
                    <Field
                      type="checkbox"
                      showErrors={false}
                      label={
                        <span>
                          I agree to the{' '}
                          <a href="/terms-conditions" target="_blank">
                            terms of service
                          </a>{' '}
                          and{' '}
                          <a href="/privacy-policy" target="_blank">
                            {' '}
                            privacy policy.
                          </a>
                        </span>
                      }
                      id="acceptedTerms"
                      name="acceptedTerms"
                      checkedReturn={'boolean'}
                      checked={basicValues['acceptedTerms']}
                      onChange={({ checked }) => {
                        this.handleTermsChange(checked)
                      }}
                    />
                    {basicErrors.acceptedTerms && (
                      <div
                        className="has-text-danger is-size-7"
                        style={{ marginTop: '-.5rem' }}
                      >
                        {basicErrors.acceptedTerms}
                      </div>
                    )}
                  </Columns.Column>
                </Columns>

                <Columns>
                  <Columns.Column>
                    <Button
                      size="medium"
                      fullwidth
                      color="primary"
                      loading={basicLoading}
                      disabled={basicDisabled}
                      onClick={(e) => this.handleBasicInfo(e, auth.logIn)}
                    >
                      Sign Up
                    </Button>
                  </Columns.Column>
                </Columns>
              </form>
            </React.Fragment>
          )
        }}
      </Subscribe>
    )
  }
}

export default withRouter(SignUpBasicInfo)

SignUpBasicInfo.defaultProps = {
  onSuccess: null,
}
